import { useEffect, useState } from 'react'
import api from '../services/api'

// Cadastro rápido dos e-mails de envio do cliente (mesma aba "E-mails" do cadastro de
// clientes, frota.clifro), aberto direto da janela de envio de XML/DANFE por e-mail.

export type TipoEmailNota = 'N' | 'M' | 'O' // NF-e, NFS-e, CT-e OS

const CAMPOS: [string, string, string][] = [
  ['clifroem1', 'E-mail NF-e', 'NF-e'],
  ['clifroem2', 'E-mail NFS-e', 'NFS-e'],
  ['clifroem3', 'E-mail CT-e OS', 'CT-e OS'],
  ['clifroem4', 'E-mail Cópia', 'Cópia'],
  ['clifroem5', 'E-mail Cópia 2', 'Cópia'],
  ['clifroem6', 'E-mail Cópia 3', 'Cópia'],
  ['clifroem7', 'E-mail Cópia 4', 'Cópia'],
]
const PRINCIPAL: Record<TipoEmailNota, string> = { N: 'clifroem1', M: 'clifroem2', O: 'clifroem3' }

export default function CadastroEmailsClienteModal({ doc, nome, tipo, onClose, onSalvo }: {
  doc: string
  nome: string
  tipo: TipoEmailNota
  onClose: () => void
  onSalvo: (principal: string, copias: string[]) => void
}) {
  const [v, setV] = useState<Record<string, string> | null>(null)
  const [erro, setErro] = useState('')
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    api.get(`/erp/clientes-emails/${encodeURIComponent(doc)}`)
      .then(r => setV(r.data))
      .catch(e => setErro(e?.response?.data?.error || 'Erro ao carregar os e-mails do cliente.'))
  }, [doc])

  async function salvar() {
    if (!v) return
    setErro(''); setSalvando(true)
    try {
      const r = await api.put(`/erp/clientes-emails/${encodeURIComponent(doc)}`, v)
      const d = r.data
      onSalvo(d[PRINCIPAL[tipo]] || '', ['clifroem4', 'clifroem5', 'clifroem6', 'clifroem7'].map(c => d[c]).filter(Boolean))
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar os e-mails.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div onClick={e => { e.stopPropagation(); if (e.target === e.currentTarget) onClose() }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 10, width: 520, maxWidth: '94vw', boxShadow: '0 20px 50px rgba(0,0,0,.3)', overflow: 'hidden' }}>
        <div style={{ background: '#1b3f7b', color: '#fff', padding: '0.8rem 1.1rem' }}>
          <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>E-mails do cliente</div>
          <div style={{ fontSize: '0.78rem', color: '#dbeafe', marginTop: 2 }}>{nome}</div>
        </div>
        <div style={{ padding: '1rem 1.1rem' }}>
          {!v ? (
            <div style={{ textAlign: 'center', padding: '1.5rem', color: erro ? '#dc2626' : '#9ca3af', fontSize: '0.85rem' }}>{erro || 'Carregando...'}</div>
          ) : (
            <>
              {CAMPOS.map(([campo, rotulo, tag]) => {
                const destaque = campo === PRINCIPAL[tipo]
                return (
                  <div key={campo} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 7 }}>
                    <label style={{ width: 110, fontSize: '0.78rem', fontWeight: 600, color: destaque ? '#1b3f7b' : '#374151', flexShrink: 0 }}>{rotulo}</label>
                    <input value={v[campo] || ''} maxLength={50} placeholder="email@exemplo.com"
                      onChange={e => setV(p => ({ ...p!, [campo]: e.target.value }))}
                      style={{
                        flex: 1, border: `1px solid ${destaque ? '#1b3f7b' : '#d1d5db'}`, borderRadius: 4, padding: '6px 8px', fontSize: '0.85rem',
                        background: destaque ? '#eef3f9' : '#fff',
                      }} />
                    <span style={{ width: 58, textAlign: 'center', fontSize: '0.7rem', fontWeight: 600, color: '#6b7280', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px 0', flexShrink: 0 }}>{tag}</span>
                  </div>
                )
              })}
              <p style={{ fontSize: '0.74rem', color: '#6b7280', margin: '0.6rem 0 0' }}>
                Grava no cadastro do cliente (aba E-mails). O campo destacado é o usado neste envio; as cópias vão em todos os tipos de nota.
              </p>
              {erro && <div style={{ color: '#dc2626', fontSize: '0.78rem', marginTop: 8 }}>{erro}</div>}
            </>
          )}
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <button className="btn btn-sm" onClick={onClose} disabled={salvando} style={{ color: '#6b7280' }}>Cancelar</button>
            <button className="btn btn-sm btn-primary" onClick={salvar} disabled={salvando || !v}>{salvando ? 'Salvando...' : 'Salvar e-mails'}</button>
          </div>
        </div>
      </div>
    </div>
  )
}
